<img
	alt="eKomi logo"
	class="max-h-full object-contain"
	src="{{ assetDomain }}assets/ui/images/reviews/ekomi-{{
		getEkomiLogoType(score)
	}}-{{ localeHelper.language }}.png"
/>
